import { withSvgIcon } from './withSvgIcon';

export const Edit = withSvgIcon(
  <path
    d="M5.75383 14.7385L4.01905 19.5268C3.92548 19.8075 4.19252 20.0745 4.47321 19.981L9.2615 18.2462L19.346 8.16163C20.1392 7.36845 20.3485 5.96934 19.1896 4.8104C18.0307 3.65145 16.6316 3.86078 15.8384 4.65397L5.75383 14.7385Z"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="square"
    strokeLinejoin="round"
  />,
  { viewBox: '0 0 24 24' },
);
